
import React from "react";

export function PromptListEmpty() {
  return (
    <div className="p-8 text-center text-github-text opacity-70">
      <p>No prompts found. Try adjusting your filters.</p>
    </div>
  );
}
